var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4532 13.5128C20.1754 16.1227 18.6967 18.5684 16.2497 19.9812C12.1842 22.3284 6.98566 20.9355 4.63845 16.87L4.38845 16.437M3.54617 11.7271C3.82397 9.11723 5.30276 6.6715 7.74974 5.25873C11.8152 2.91152 17.0138 4.30446 19.361 8.36995L19.611 8.80296M3.49316 18.6859L4.22522 15.9539L6.95727 16.6859M17.0422 8.55397L19.7743 9.28602L20.5063 6.55397M11.9997 8.11995V12.6199L14.4997 14.1199",
    stroke: "#378ED1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRefresh);
export default __webpack_public_path__ + "static/media/clockRefresh.9b31d9ed7b0138b5ac02c38e17540f10.svg";
export { ForwardRef as ReactComponent };